import { notificationInstance } from '@/shared/api/api-instances/notification/api-instance';
import type { Sender, SenderItem } from '../model/sender';
import type { AxiosRequestConfig } from 'axios';

export class SendersApi {
  static getSenders(options: AxiosRequestConfig = {}) {
    return notificationInstance.get<SenderItem[]>(`/senders`, options);
  }

  static getSenderByID(id: string, options: AxiosRequestConfig = {}) {
    return notificationInstance.get<Sender>(`/sender/${id}`, options);
  }

  static updateSender(
    id: string,
    payload: Omit<Sender, 'id'>,
    options: AxiosRequestConfig = {},
  ) {
    return notificationInstance.put(`/sender/${id}`, payload, options);
  }

  static createSender(
    payload: Omit<Sender, 'id'>,
    options: AxiosRequestConfig = {},
  ) {
    return notificationInstance.post('/sender', payload, options);
  }

  static deleteSender(
    id: string,
    force: boolean = false,
    options: AxiosRequestConfig = {},
  ) {
    return notificationInstance.delete<void>(`/sender/${id}`, {
      ...options,
      params: { force: force },
    });
  }
}